import * as DetectBrowser from "detect-browser";
import * as React from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import { FaQuestionCircle } from "react-icons/fa";
import { MdCheck } from "react-icons/md";
import { Translate } from "react-localize-redux";
import { UncontrolledTooltip, Button } from "reactstrap";
import "./PackageExtraCard.scss";
import Number from "./Number";

interface IPackage {
  disabled?: boolean;
  extraPrice?: number;
  extraUnit?: string;
  features?: string[];
  price?: number;
  quantity: number;
  recommended?: boolean;
  sku: string;
  tooltipText?: string;
  unit?: string;
}
interface IProps {
  hasInput?: boolean;
  package: IPackage;
  packageSelected: any;
  priceUnit?: string;
  quantityChanged?: any;
  recommended?: boolean;
  selected?: boolean;
  type?: "large" | "small";
}
interface IState {
  isHovered: boolean;
}
class PackageExtraCard extends React.Component<IProps, IState> {
  private tooltipRef: React.RefObject<HTMLElement> = React.createRef();

  public constructor(props: IProps) {
    super(props);

    this.state = {
      isHovered: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleMinus = this.handleMinus.bind(this);
    this.handlePlus = this.handlePlus.bind(this);
    this.onQuantityChanged = this.onQuantityChanged.bind(this);
  }

  public render() {
    if (this.props.type !== "small") {
      return (
        <div className={"package-card card extra " + (this.state.isHovered && !this.props.package.disabled ? "shadow" : "") + (this.props.package.disabled ? " disabled" : "")} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
          {!this.props.package.tooltipText ? null : (
            <span>
              <span className="help-tooltip" ref={this.tooltipRef}>
                <FaQuestionCircle />
              </span>
              {this.tooltipRef.current ? (
                <UncontrolledTooltip placement="right" target={this.tooltipRef.current} autohide={false}>
                  {this.props.package.tooltipText}
                </UncontrolledTooltip>
              ) : null}
            </span>
          )}
          <div className="card-body">
            <div className="card-title text-center">
              {this.props.package.sku !== "NV-nvpalkp" ? (
                <h5>
                  <Translate id={this.props.package.sku + ".name"} />
                </h5>
              ) : (
                <h3>
                  <Translate id={this.props.package.sku + ".name"} />
                </h3>
              )}
            </div>
            <div className="card-text text-center">
              <Translate>
                {({ translate }) => {
                  return <div>{translate(this.props.package.sku + ".description", undefined, { onMissingTranslation: () => "" })}</div>;
                }}
              </Translate>
              {this.props.package.features && this.props.package.features.length ? (
                <div>
                  <hr />
                  {(this.props.package.features || []).map((f: string, idx: number) => {
                    return (
                      <div className="small" key={idx}>
                        <Translate id={f} />
                      </div>
                    );
                  })}
                </div>
              ) : null}
              {!this.props.hasInput ? null : (
                <div>
                  {this.props.package.disabled ? (
                    <div className="input-group my-3">
                      <span className="input-group-btn input-group-prepend">
                        <Button className="text-primary btn btn-default btn-number" disabled={true} data-type="minus" onClick={this.handleMinus}>
                          <FaMinus size="1.5em" />
                        </Button>
                      </span>
                      <input type="number" className="form-control input-number text-center" disabled={true} value={this.props.package.quantity} min="0" max="100000" onChange={this.onQuantityChanged} onFocus={this.handleFocus} />
                      <span className="input-group-btn input-group-append">
                        <Button className="text-primary btn btn-default btn-number" data-type="plus" disabled={true} onClick={this.handlePlus}>
                          <FaPlus size="1.5em" />
                        </Button>
                      </span>
                    </div>
                  ) : (
                    <div className="input-group my-3">
                      <span className="input-group-btn input-group-prepend">
                        <Button className="text-primary btn btn-default btn-number" data-type="minus" onClick={this.handleMinus}>
                          <FaMinus size="1.5em" />
                        </Button>
                      </span>
                      <input type="number" className="form-control input-number text-center" value={this.props.package.quantity} min="0" max="100000" onChange={this.onQuantityChanged} onFocus={this.handleFocus} />
                      <span className="input-group-btn input-group-append">
                        <Button className="text-primary btn btn-default btn-number" data-type="plus" onClick={this.handlePlus}>
                          <FaPlus size="1.5em" />
                        </Button>
                      </span>
                    </div>
                  )}
                  <div>{this.props.package.unit}</div>
                </div>
              )}
            </div>
          </div>
          <div className="card-footer text-center border-0">
            <div className="price">
              <span>{this.props.package.price ? this.props.package.price.toFixed(2) : "N/A"}</span> <span>{this.props.priceUnit ? <Translate id={this.props.priceUnit} /> : <Translate id="EuroPerMonth" />} </span>
            </div>
            <div className="tax">
              <Translate id="Tax0" />
            </div>
            {this.props.package.extraUnit ? (
              <div>
                <hr className="my-2" />
                <div className="font-weight-bold text-dark">
                  <Number value={this.props.package.extraPrice || 0} /> <span>{this.props.package.extraUnit}</span>
                </div>
              </div>
            ) : null}
            <button onClick={this.handleClick} className={"mt-3 btn btn-primary btn-block " + (this.props.selected ? "btn-success p-0" : "")} disabled={this.props.package.disabled}>
              {!this.props.package.disabled ? (
                <span>
                  <span className={"checked " + (this.props.selected ? "visible" : "invisible")}>
                    <MdCheck />
                  </span>
                  <span className={"unchecked " + (!this.props.selected ? "visible" : "invisible")}>
                    <Translate id="Select" />
                  </span>
                </span>
              ) : (
                <span className={"unchecked "}>
                  <Translate id="NonSelectable" />
                </span>
              )}
            </button>
          </div>
          {this.props.recommended ? (
            <div className="recommended-badge text-uppercase">
              <span>
                <Translate id="Popular" />
              </span>
            </div>
          ) : null}
        </div>
      );
    }

    return (
      <>
        <div className={"package-card card small extra "} onMouseOver={this.handleHover} onMouseOut={this.handleHover}>
          <div className="card-body d-flex justify-content-between align-items-center">
            <div>
              <div className="card-title">
                <h5>
                  <Translate id={this.props.package.sku + ".name"} />
                </h5>
              </div>
              <div className="card-text">
                <Translate>
                  {({ translate }) => {
                    return <span>{translate(this.props.package.sku + ".description", undefined, { onMissingTranslation: () => "" })}</span>;
                  }}
                </Translate>
              </div>
            </div>
            <div className="d-flex justify-content-end flex-wrap">
              <div className="price">
                <span>{this.props.package.price ? this.props.package.price.toFixed(2) : "N/A"}</span>{" "}
                <span>
                  <Translate id="EuroPerMonth" />
                </span>
                <div className="tax text-right">
                  <Translate id="Tax0" />
                </div>
              </div>
              <label className="switch ml-3">
                <input type="checkbox" checked={this.props.selected} onChange={this.handleClick} disabled={this.props.package.disabled} />
                <span className="slider round" />
              </label>
            </div>
          </div>
        </div>
        {this.props.package.sku === "NV-rb" && this.state.isHovered && this.props.package.disabled && (
          <div className="tooltip-orange">
            <span className="tooltip-text">
              <Translate id={"Rackbeat"} />
            </span>
          </div>
        )}
      </>
    );
  }

  private handleFocus(event: React.FocusEvent<HTMLInputElement>) {
    // Select all with a hack that works on all browsers
    const browser = DetectBrowser.detect();
    if (browser && browser.name === "safari") {
      event.target.setAttribute("type", "text");
      event.target.setSelectionRange(0, 9999);
      event.target.setAttribute("type", "number");
    } else {
      event.target.select();
    }
  }

  private handleClick() {
    this.props.packageSelected(this.props.package.sku);
  }

  private handleHover() {
    this.setState({ isHovered: !this.state.isHovered });
  }

  private onQuantityChanged(event: React.FormEvent<HTMLInputElement>) {
    let newQuantity = parseInt(event.currentTarget.value, 10);

    if (newQuantity >= 0) {
      const max = +event.currentTarget.max || 10000;
      if (newQuantity > max) {
        newQuantity = max;
      }
      const selectPackage = newQuantity === 0 ? false : true;
      this.props.quantityChanged(this.props.package.sku, newQuantity, selectPackage);
    } else if (event.currentTarget.value === "") {
      this.props.quantityChanged(this.props.package.sku, 0, false);
    }
  }

  private handleMinus() {
    const newQuantity = this.props.package.quantity - 1;
    if (newQuantity >= 0) {
      const selectPackage = newQuantity === 0 ? false : undefined;
      this.props.quantityChanged(this.props.package.sku, newQuantity, selectPackage);
    }
  }

  private handlePlus(event: React.MouseEvent<HTMLButtonElement>) {
    let newQuantity = this.props.package.quantity + 1;
    const max = event.currentTarget.parentElement ? (event.currentTarget.parentElement.parentElement ? (event.currentTarget.parentElement.parentElement.querySelector("input") || { max: 100000 }).max : 100000) : 100000;
    if (newQuantity > +max) {
      newQuantity = +max;
    }
    const selectPackage = this.props.selected ? undefined : true;
    this.props.quantityChanged(this.props.package.sku, newQuantity, selectPackage);
  }
}

export default PackageExtraCard;
